/**
 * カレンダー（Flatpickr）初期化
 *
 * Blade 側で <script type="application/json" data-calendar-for="inputId"> に
 * 設定 JSON を出力。このスクリプトが自動検出して Flatpickr を初期化する。
 */

/**
 * 指定セレクタ、または data-calendar-config 属性を持つ全要素を初期化
 */
window.initCalendars = function (selector) {
    var targets = document.querySelectorAll(selector || '[data-calendar-config]');

    targets.forEach(function (el) {
        if (el._flatpickr) return;

        var raw = el.getAttribute('data-calendar-config');
        if (!raw) return;

        var cfg;
        try {
            cfg = JSON.parse(raw);
        } catch (e) {
            return;
        }

        initFlatpickr(el, cfg);
    });
};

/**
 * JSON 設定をもとに Flatpickr を初期化しボタンイベントを登録
 */
function initFlatpickr(el, cfg) {
    var closedDays = cfg.closedDays || [];

    var dpConfig = {
        dateFormat: cfg.dateFormat || 'Y-m-d',
        locale: cfg.locale || 'ja',
        enableTime: !!cfg.enableTime,
        noCalendar: !!cfg.noCalendar,
        time_24hr: cfg.time_24hr !== false,
        allowInput: !!cfg.allowInput,
        onDayCreate: function (_dObj, _dStr, fp, dayElem) {
            var dow = dayElem.dateObj.getDay();
            var dateStr = fp.formatDate(dayElem.dateObj, 'Y-m-d');
            if (dow === 0 || closedDays.indexOf(dateStr) !== -1) {
                dayElem.classList.add('sunday');
            } else if (dow === 6) {
                dayElem.classList.add('saturday');
            }
        },
    };

    if (cfg.inline) dpConfig.inline = true;
    if (cfg.showMonths && cfg.showMonths > 1) dpConfig.showMonths = cfg.showMonths;
    if (cfg.minDate) dpConfig.minDate = new Date().fp_incr(cfg.minDate);
    if (cfg.maxDate) dpConfig.maxDate = new Date().fp_incr(cfg.maxDate);
    if (cfg.mode && cfg.mode !== 'single') dpConfig.mode = cfg.mode;
    if (cfg.disable && cfg.disable.length) dpConfig.disable = cfg.disable;
    if (cfg.enable && cfg.enable.length) dpConfig.enable = cfg.enable;

    // defaultDate は Blade の <x-calendar>（Calendar コンポーネント）が JSON で渡す値のみ。JS 側で today を補わない。
    if (cfg.defaultDate !== undefined && cfg.defaultDate !== null && cfg.defaultDate !== '') {
        dpConfig.defaultDate = cfg.defaultDate;
    }

    flatpickr(el, dpConfig);

    var elId = el.id;
    if (!elId) return;

    document.querySelectorAll("button[for='" + elId + "']").forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            if (!el || el.disabled) return;

            var fpObject = el._flatpickr;
            if (!fpObject) return;

            var withAction = btn.getAttribute('with_action');
            switch (withAction) {
                case 'show':
                    fpObject.open();
                    break;
                case 'clear':
                    fpObject.clear();
                    break;
            }
        });
    });
}

/**
 * DOMContentLoaded で JSON config タグを検出し、対応する input を初期化
 */
document.addEventListener('DOMContentLoaded', function () {
    var configScripts = document.querySelectorAll('script[type="application/json"][data-calendar-for]');

    configScripts.forEach(function (scriptEl) {
        var targetId = scriptEl.getAttribute('data-calendar-for');
        var el = document.getElementById(targetId);
        if (!el) return;

        var cfg;
        try {
            cfg = JSON.parse(scriptEl.textContent);
        } catch (e) {
            return;
        }

        el.setAttribute('data-calendar-config', scriptEl.textContent);
        initFlatpickr(el, cfg);
    });
});
